export default __webpack_public_path__ + "static/media/seattleSeahawks@2x.3b98768d.jpg";